const heroHome = () => {
  const heroText1 = document.querySelector(".heroText1");
  if (heroText1) {
    gsap.fromTo(
      heroText1,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        delay: 1,
      }
    );
  }

  const heroText2 = document.querySelector(".heroText2");
  if (heroText2) {
    gsap.to(heroText2, {
      duration: 2,
      delay: 3,
      text: {
        value: "Leidi Pandini",
      },
      ease: "ease-in-out",
    });
  }

  const heroText3 = document.querySelector(".heroText3");
  if (heroText3) {
    gsap.fromTo(
      heroText3,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        delay: 5,
      }
    );
  }

  sectionAnimation(".wp-block-publifarm-columns");
  sectionAnimation(".accordion__section");
  sectionAnimation(".services__section");
  sectionAnimation(".text-carousel__section");
  sectionAnimation(".pubblicazioni__section");
  sectionAnimation(".blog__section");
};

export default heroHome;

const sectionAnimation = (selector) => {
  const sections = document.querySelectorAll(selector);
  if (sections.length > 0) {
    sections.forEach((section) => {
      gsap.fromTo(
        section,
        {
          // y: -50,
          opacity: 0,
        },
        {
          // y: 0,
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            // markers: true,
            // end: "bottom top",
          },
        }
      );
    });
  }
};
